<template>
  <AnablueSidebar
    data-v-step="sidebar"
    :items="sidebarItems"
    :minimize="$store.state.sidebarMinimize"
    @update:minimize="
      (value) => $store.commit('set', ['sidebarMinimize', value])
    "
  />
</template>

<script>
import { getSidebarNav } from "./_nav";

export default {
  name: 'TheSidebar',
  computed: {
    sidebarItems() {
      return getSidebarNav();
    },
  },
}
</script>
